import type { Organization, Reference } from '@medplum/fhirtypes'
import { ExtendedOrganization } from '@seen/core/models/organizations/ExtendedOrganization'
import { cn } from '@seen/ui'
import { IconBuilding } from '@tabler/icons-react'
import { cva, type VariantProps } from 'class-variance-authority'
import type { JSX } from 'react'
import { IconFax } from '#src/components/icons/IconFax.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { useReference } from '#src/hooks/useReference.ts'

interface OrganizationNameplateProps extends VariantProps<typeof variants> {
  organization: Reference<Organization> | string
  className?: string
}

export function OrganizationNameplate({
  organization,
  size,
  className,
  faxNumber,
}: OrganizationNameplateProps & { faxNumber?: string }): JSX.Element {
  const organizationReference = useReference(organization)
  const { data: instance } = useRead(
    ExtendedOrganization,
    organizationReference
  )
  return (
    <div className={cn(variants({ size, className }))}>
      <IconBuilding size={16} className="shrink-0 text-muted-foreground" />
      <div className="flex flex-col">
        <p>{instance?.name}</p>
        {faxNumber && (
          <span className="flex items-center gap-1 text-xs text-muted-foreground">
            <IconFax className="size-4 shrink-0" /> {faxNumber}
          </span>
        )}
      </div>
    </div>
  )
}

const variants = cva('flex items-center', {
  variants: {
    size: {
      5: 'gap-2',
      3.5: 'gap-1',
      3: 'gap-1',
    },
  },
  defaultVariants: {
    size: 5,
  },
})
